export default __webpack_public_path__ + "e12558653878786ea7d23545450bf8d9.ply";